/**
 * Utilitaires pour le lecteur d'overlays : titres, IDs, normalisation de config.
 */

/**
 * Retourne le libellé d'affichage pour un overlay (titre ou "Anniversaires").
 * @param {{ overlayType?: string, rewardTitle?: string }} overlay - Données de l'overlay courant
 * @returns {string}
 */
export function getOverlayDisplayTitle(overlay) {
  if (!overlay) return '';
  if (overlay.overlayType === 'birthday') return 'Anniversaires';
  return overlay.rewardTitle || '';
}

/**
 * Génère un identifiant unique pour un overlay (déduplication).
 * @param {{ id?: string, rewardId?: string, timestamp?: number|string, userName?: string }} data - Données reçues de l'événement overlay.show
 * @returns {string}
 */
export function buildOverlayId(data) {
  if (data?.id) return String(data.id);
  const rewardId = data?.rewardId ?? '';
  const timestamp = data?.timestamp ?? Date.now();
  const userName = data?.userName ?? '';
  return `${rewardId}-${timestamp}-${userName}`;
}

/**
 * Normalise la config du leaderboard (showWhen, displayDurationSeconds, rewardName).
 * @param {{ showWhen?: string, displayDurationSeconds?: number, rewardName?: string } | null} config - Config brute
 * @param {{ minSec: number, maxSec: number, defaultSec: number, defaultRewardName: string }} bounds - Bornes et défauts
 * @returns {{ showWhen: 'always'|'onRewardOnly', displayDurationSeconds: number, rewardName: string }}
 */
export function normalizeLeaderboardConfig(config, bounds) {
  const showWhen =
    config?.showWhen === 'onRewardOnly' ? 'onRewardOnly' : 'always';
  const displayDurationSeconds = Math.max(
    bounds.minSec,
    Math.min(
      bounds.maxSec,
      Number(config?.displayDurationSeconds) || bounds.defaultSec
    )
  );
  const rewardName =
    (config?.rewardName && String(config.rewardName).trim()) ||
    bounds.defaultRewardName;
  return { showWhen, displayDurationSeconds, rewardName };
}
